<div class="close-important-drawer" (click)="closeNotificationDrawer()">
  <i _ngcontent-serverapp-c177="" class="material-icons">close</i>
</div>
<ng-container *ngFor="let data of updates">
  <div
    class="important-updates-card mb-3"
    (click)="data?.redirect_type == 'external' ? null : navigateToDetails(data)"
    [ngClass]="
      data?.type != 'view_only' && data?.redirect_type != 'external'
        ? 'cursor-pointer'
        : ''
    "
  >
    <div
      class="important-updates-card__left"
      *ngIf="data?.department?.department_logo_url || data?.image_url"
      [style.background]="
        !data?.department?.department_logo_url && data?.tag_color
      "
    >
      <img
        height="42px"
        width="42px"
        [src]="data?.department?.department_logo_url || data?.image_url"
        alt="icon_color"
      />
    </div>
    <!-- <div class="important-updates-card__left" *ngIf="data?.department?.department_logo_url && !data?.image_url">
            <img  height="42px" width="42px" [src]="data?.department?.department_logo_url" alt="icon_color">
        </div> -->
    <div
      class="important-updates-card__left"
      *ngIf="data?.sub_type == 'announcement' && !data?.image_url"
    >
      <img
        height="42px"
        width="42px"
        src="assets/images/notifications-icon.svg"
        alt="icon_color"
      />
    </div>
    <div
      class="important-updates-card__left"
      *ngIf="data?.sub_type == 'schemes' && !data?.image_url"
    >
      <img
        height="42px"
        width="42px"
        src="assets/images/schemes-icon.svg"
        alt="icon_color"
      />
    </div>
    <div class="important-updates-card__right">
      <p class="important-updates-card__title">{{ data?.title }}</p>
      <p class="important-updates-card__subtitle">{{ data?.body }}</p>
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <span
            class="important-updates-card__tagname"
            [style.color]="data?.tag_color"
            >{{ data?.tag_name }}</span
          >
          <span class="name"> . {{ data?.updated_at | timeAgo }}</span>
        </div>
        <button
          class="mb-0 important-btn"
          (click)="navigateToDetails(data)"
          *ngIf="data?.redirect_type == 'external'"
        >
          {{ data?.button_title || "Open" }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
